export const getBusinessText = (organizationType) => {
    if (organizationType === 2) {
        return "Starter Business";
    } if(organizationType === 1) {
        return "Registered Business";
    }else{
    return null}

};